import { render, staticRenderFns } from "./attentioncar.vue?vue&type=template&id=105c13a0&scoped=true&"
import script from "./attentioncar.vue?vue&type=script&lang=js&"
export * from "./attentioncar.vue?vue&type=script&lang=js&"
import style0 from "./attentioncar.vue?vue&type=style&index=0&id=105c13a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105c13a0",
  null
  
)

export default component.exports